import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { StoreMarketResponse, StoreMarketTreeResponse } from './store.types';
import { Organization } from '../menu/menu.types';

export const useMarkets = (requestBody: {otherFlag?: boolean, hasPendingMenus?: boolean}, enabled: boolean = false) => {
  return useQuery<AxiosResponse<string[]>>({
    queryKey: ['markets', requestBody.otherFlag, requestBody.hasPendingMenus],
    queryFn: () => apiClient.get<string[]>('/markets',{ params: requestBody }),
    enabled,
  });
};

export const useStoreMarkets = (requestBody: { marketNo?: string, storeType?: number, hasPendingMenus?: boolean }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<StoreMarketResponse[]>>({
    queryKey: ['storeMarkets', requestBody.marketNo, requestBody.storeType],
    queryFn: () => apiClient.get<StoreMarketResponse[]>('/store-markets', { params: requestBody }),
    enabled,
  });
};

export const useStoreMarketsOrganizations = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Organization[]>>({
    queryKey: ['storeMarketsOrganizations'],
    queryFn: () => apiClient.get<Organization[]>('/store-markets/organizations'),
    enabled,
  });
};

export const useStoreInMarkets = (requestBody: { marketNo?: string, statusNo?: number }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<StoreMarketTreeResponse[]>>({
    queryKey: ['storeMarkets', requestBody.marketNo, requestBody.statusNo],
    queryFn: () => apiClient.get<StoreMarketTreeResponse[]>('/store-in-market', { params: requestBody }),
    enabled,
  });
};

export const useStoreMarketsRecord = (storeNo: string | undefined, enabled: boolean = false) => {
  return useQuery<AxiosResponse<StoreMarketResponse, any>>({
    queryKey: 'storeMarketRecord',
    queryFn: () => apiClient.get<StoreMarketResponse>(`/store-markets/${storeNo}`),
    enabled,
  });
};